export default {
  computed: {
    line_items() {
      let line_items = []

      const pledge = this.order.products.pledge

      const standardPrice = (!pledge && this.order.product_prices?.arsenal_2_standard.sale) || this.prices.arsenal_2_standard.sale
      const proPrice = (!pledge && this.order.product_prices?.arsenal_2_pro.sale) || this.prices.arsenal_2_pro.sale
      const phoneMountPrice = this.order.product_prices?.phone_mount.sale || this.prices.phone_mount.sale
      const batteryPrice = this.order.product_prices?.battery.sale || this.prices.battery.sale
      const microSdCardPrice = this.order.product_prices?.micro_sd_card.sale || this.prices.micro_sd_card.sale

      if (pledge && pledge.quantity > 0) {
        let total = 0
        if (pledge.arsenal_model == 'Arsenal 2 Standard') {
          total = standardPrice * pledge.quantity
        } else {
          total = proPrice * pledge.quantity
        }
        line_items.push({ name: pledge.arsenal_model, quantity: pledge.quantity, total })
        pledge.cables.forEach((cable, index) => {
          if (cable == '') return
          let parts = cable.split(' - ')
          let price = ((pledge.quantity - index) > 0) ? 0 : this.prices.cable.sale
          line_items.push({ name: `${parts[1]} for ${parts[0]}`, quantity: 1, total: price })
        })
      }

      const arsenal_pro = this.order.products.arsenal_pro
      if (arsenal_pro.quantity > 0) {
        line_items.push({ name: 'Arsenal 2 Pro', quantity: arsenal_pro.quantity, total: proPrice * arsenal_pro.quantity })
      }

      arsenal_pro.cables.forEach((cable, index) => {
        if (cable == '') return
        let parts = cable.split(' - ')
        let price = ((arsenal_pro.quantity - index) > 0) ? 0 : this.prices.cable.sale
        line_items.push({ name: `${parts[1]} for ${parts[0]}`, quantity: 1, total: price })
      })

      const arsenal = this.order.products.arsenal
      if (arsenal.quantity > 0) {
        if (this.hide_pro) {
          // remove model name from Arsenal since we are hiding Pro models
          line_items.push({ name: 'Arsenal 2', quantity: arsenal.quantity, total: standardPrice * arsenal.quantity })
        } else {
          line_items.push({ name: 'Arsenal 2 Standard', quantity: arsenal.quantity, total: standardPrice * arsenal.quantity })
        }
      }
      arsenal.cables.forEach((cable, index) => {
        if (cable == '') return
        let parts = cable.split(' - ')
        let price = ((arsenal.quantity - index) > 0) ? 0 : this.prices.cable.sale
        line_items.push({ name: `${parts[1]} for ${parts[0]}`, quantity: 1, total: price })
      })

      const phone_mount = this.order.products.phone_mount
      if (phone_mount.quantity > 0) {
        line_items.push({ name: 'Phone + Arsenal Mount', quantity: phone_mount.quantity, total: phoneMountPrice * phone_mount.quantity })
      }

      const battery = this.order.products.battery
      if (battery.quantity > 0) {
        line_items.push({ name: 'USB Powerbank', quantity: battery.quantity, total: batteryPrice * battery.quantity })
      }

      const micro_sd_card = this.order.products.micro_sd_card
      if (micro_sd_card.quantity > 0) {
        line_items.push({ name: 'Micro SD Card', quantity: micro_sd_card.quantity, total: microSdCardPrice * micro_sd_card.quantity })
      }

      return line_items
    },
    tax_label() {
      switch (this.order.shipping_address.country) {
        case 'United States of America':
          return 'Estimated Tax'
        case 'Australia':
        case 'Canada':
          return 'Estimated GST'
        default:
          return 'Estimated VAT'
      }
    }
  }
}
